// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* 검색 & 버튼 */
.input-container {
    display: flex;
    padding: 10px;
    gap: 10px;
    background: #f8f9fa;
    border-bottom: 1px solid #ddd;
}

input {
    flex-grow: 1;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
}

button {
    background: #03c75a;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
}

button:hover {
    background: #029e47;
}

button:disabled {
    background: #ccc;
    cursor: not-allowed;
}

/* 이메일 목록과 본문을 flex로 배치 */
.email-container {
    display: flex;
    flex-grow: 1;
    overflow: hidden;
}

/* 이메일 리스트 */
.email-list {
    width: 30%;
    border-right: 1px solid #ddd;
    background: #ffffff;
    overflow-y: auto;  /* 스크롤 가능하게 설정 */
    display: flex;
    flex-direction: column;
    max-height: 100%;  /* 최대 높이 설정 */
    height: 100%;  /* 부모 요소에 맞춰서 100% 높이 */
}

.email-list li {
    padding: 15px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    transition: background 0.3s;
    white-space: nowrap; /* 줄바꿈 방지 */
    overflow: hidden; /* 넘치는 내용 숨기기 */
    text-overflow: ellipsis; /* '...'으로 표시 */
}

.email-list li:hover {
    background: #f2f2f2;
}

.email-list li.selected {
    background: #e8f5e9;
    border-left: 5px solid #03c75a;
}

/* 이메일 본문 */
.email-content {
    flex-grow: 1;
    padding: 20px;
    background: white;
    overflow-y: auto;
}

/* 반응형 (모바일) */
@media (max-width: 768px) {
    .email-container {
        flex-direction: column;
    }

    .email-list {
        width: 100%;
        height: 40%;
        border-right: none;
        border-bottom: 1px solid #ddd;
    }

    .email-content {
        width: 100%;
        height: 60%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA,YAAY;AACZ;IACI,aAAa;IACb,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,UAAU;IACV,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB,GAAG,gBAAgB;IACnC,aAAa;IACb,sBAAsB;IACtB,gBAAgB,GAAG,aAAa;IAChC,YAAY,GAAG,uBAAuB;AAC1C;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,2BAA2B;IAC3B,mBAAmB,EAAE,WAAW;IAChC,gBAAgB,EAAE,eAAe;IACjC,uBAAuB,EAAE,eAAe;AAC5C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA,WAAW;AACX;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,WAAW;IACf;AACJ","sourcesContent":["\n/* 검색 & 버튼 */\n.input-container {\n    display: flex;\n    padding: 10px;\n    gap: 10px;\n    background: #f8f9fa;\n    border-bottom: 1px solid #ddd;\n}\n\ninput {\n    flex-grow: 1;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n}\n\nbutton {\n    background: #03c75a;\n    color: white;\n    border: none;\n    padding: 10px 15px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-weight: bold;\n}\n\nbutton:hover {\n    background: #029e47;\n}\n\nbutton:disabled {\n    background: #ccc;\n    cursor: not-allowed;\n}\n\n/* 이메일 목록과 본문을 flex로 배치 */\n.email-container {\n    display: flex;\n    flex-grow: 1;\n    overflow: hidden;\n}\n\n/* 이메일 리스트 */\n.email-list {\n    width: 30%;\n    border-right: 1px solid #ddd;\n    background: #ffffff;\n    overflow-y: auto;  /* 스크롤 가능하게 설정 */\n    display: flex;\n    flex-direction: column;\n    max-height: 100%;  /* 최대 높이 설정 */\n    height: 100%;  /* 부모 요소에 맞춰서 100% 높이 */\n}\n\n.email-list li {\n    padding: 15px;\n    border-bottom: 1px solid #eee;\n    cursor: pointer;\n    transition: background 0.3s;\n    white-space: nowrap; /* 줄바꿈 방지 */\n    overflow: hidden; /* 넘치는 내용 숨기기 */\n    text-overflow: ellipsis; /* '...'으로 표시 */\n}\n\n.email-list li:hover {\n    background: #f2f2f2;\n}\n\n.email-list li.selected {\n    background: #e8f5e9;\n    border-left: 5px solid #03c75a;\n}\n\n/* 이메일 본문 */\n.email-content {\n    flex-grow: 1;\n    padding: 20px;\n    background: white;\n    overflow-y: auto;\n}\n\n/* 반응형 (모바일) */\n@media (max-width: 768px) {\n    .email-container {\n        flex-direction: column;\n    }\n\n    .email-list {\n        width: 100%;\n        height: 40%;\n        border-right: none;\n        border-bottom: 1px solid #ddd;\n    }\n\n    .email-content {\n        width: 100%;\n        height: 60%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
